import React from 'react';
import * as Icons from '@ant-design/icons';

// 定义图标映射类型
type IconMapType = Record<string, React.ComponentType<any>>;

// 获取所有 Ant Design 图标
const allIcons: IconMapType = Icons as any;

/**
 * 根据图标名称获取图标组件
 * @param iconName 图标名称 (如 'UserOutlined')
 * @returns 图标组件或 null
 */
export const getIcon = (iconName?: string): React.ReactNode => {
    if (!iconName) {
        return null;
    }

    const IconComponent = allIcons[iconName];

    if (IconComponent) {
        return <IconComponent />;
    }

    // 默认图标 (可选)
    return null;
};

export default getIcon;
